// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Du","icon":"e_Eu","pathBg":"e_Fu","pathFg":"e_Gu","variantViolet":"e_Hu","variantBase":"e_Iu"};